<div class="open-app">
  <p>Opening application…</p>
</div>

